import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Checkbox from '../../../../../shared/form-elements/checkbox';

const Main = props =>
	<div className="params-form">
		<span className="title">{props.intl('Timeline parameters')}</span>
		<form
			action="#"
			onSubmit={e => {
				e.preventDefault();
			}}
		>
			<Field name="tickets" placeholder={props.intl('Tickets')} component={Checkbox} />
			<Field name="payouts" placeholder={props.intl('Payouts')} component={Checkbox} />
			<Field name="comments" placeholder={props.intl('Comments')} component={Checkbox} />
			<Field name="offers" placeholder={props.intl('Offers')} component={Checkbox} />
			<Field name="campaigns" placeholder={props.intl('Campaigns')} component={Checkbox} />
			<Field name="edits" placeholder={props.intl('Edits')} component={Checkbox} />
			<Field name="individual_terms" placeholder={props.intl('Individual terms')} component={Checkbox} />
			<Field name="other" placeholder={props.intl('Other')} component={Checkbox} />
			<Field name="increase_approve" placeholder={props.intl('Increase approve')} component={Checkbox} />
		</form>
	</div>;

Main.propTypes = {
	intl: PropTypes.func,
	apply: PropTypes.func
};

export default reduxForm({
	form: 'affiliateProfileParamsForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/params/main.js